module.exports = __webpack_public_path__ + "img/Neumorphism.bf9202c9.png";